module.exports = __webpack_public_path__ + "img/logo-light.5ee431c1.png";